import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import useSWR from "swr";
import urls from "../../api/urls"
import {api, HydraData} from "../../api/apiProvider";
import {Card, Flex, Space} from "antd";
import {useParams} from "react-router-dom";
import Stages from "../../components/brief/Stages";
import {useLayoutContext} from "./EditLayout";
import {Engine as EngineType, Product} from "../../api/types";
import Engine from "../../components/brief/factors/Engine";
import FactorChannels from "../../components/brief/factors/FactorChannels";
import {CSSTransition} from "react-transition-group";
import Protected from "../../roles/Protected";
import getBriefParamsString from "../../api/params";
import Roles from "../../roles/Roles";
import Forbidden from "../results/forbidden";

export default function Factors() {
  const {t} = useTranslation()
  const routeParams = useParams()
  const briefId = Number(routeParams.id) || 0

  const [engine, setEngine] = useState<EngineType>()
  const {setBrief} = useLayoutContext()
  const stagesNodeRef = useRef(null)
  const stagesButtonNodeRef = useRef(null)

  const [showStages, setShowStages] = useState(false)
  const [showStagesButton, setShowStagesButton] = useState(true)

  const {
    data: brief,
  } = useSWR<HydraData>(briefId > 0 && briefId !== 0 ? `${urls.briefs}/${briefId}?${getBriefParamsString()}` : null, api.get, {
    revalidateOnFocus: false
  })

  const {
    data: engines,
    mutate: mutateEngines,
  } = useSWR<{
    data: EngineType[]
  }>(briefId > 0 ? `${urls.engines}?brief.id=${briefId}&t[]=engine&t[]=engine:json` : null, api.get, {
    revalidateOnFocus: false
  })

  useEffect(() => {
    if (brief && brief.data) {
      setBrief({
        isAccepted: brief.data.isAccepted,
        isPao: brief.data.products && brief.data.products.some((product: Product) => product.company &&
          product.company.isBriefManyChannels)
      })
    }
  }, [brief])

  useEffect(() => {
    if (engines && engines.data && engines.data.length > 0) {
      setEngine(engines.data[0])
    }
  }, [engines])

  const updateData = () => {
    mutateEngines()
  }

  return (
    <Flex gap={'large'} justify={'flex-end'}>
      <Space direction={'vertical'} size={'middle'} style={{width: '100%'}}>
        {!engine ?
          (Roles.hasAccess('canEditModel')
              ? <Protected access={'canManageFactors'}>
                <Engine updateData={updateData}/>
              </Protected>
              : <Forbidden/>
          )

          : (
            Roles.hasAccess('canReadModel')
              ? <FactorChannels engine={engine}/>
              : <Forbidden/>
          )
        }
      </Space>

      <CSSTransition
        in={showStagesButton}
        nodeRef={stagesButtonNodeRef}
        timeout={400}
        classNames="criterion-stages-button"
        unmountOnExit
      >
        <div className={'criterion__stages-button'} onClick={() => {
          setShowStages(true)
          setShowStagesButton(false)
        }} ref={stagesButtonNodeRef}>
          <Flex justify={'space-between'} align={'center'}>
            <span className={'criterion__stages-button__text'}>{t('edit.stages')}</span>
            <span className={'criterion__stages-button__expand'}>{t('tasks.expand')}</span>
          </Flex>
        </div>

      </CSSTransition>

      <CSSTransition
        in={showStages}
        nodeRef={stagesNodeRef}
        timeout={400}
        classNames="criterion-stages"
        unmountOnExit
        onExiting={() => setShowStagesButton(true)}
      >
        <div className={'criterion__stages-block'} ref={stagesNodeRef}>
          <Flex justify={'space-between'} align={'center'} onClick={() => setShowStages(false)}>
            <span className={'criterion__stages-button__text'}>{t('edit.stages')}</span>
            <span className={'criterion__stages-button__expand'}>{t('tasks.collapse')}</span>
          </Flex>
          <Stages />
        </div>
      </CSSTransition>
    </Flex>
  )
}
